import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        language: 'en' // 默认语言
    },
    mutations: {
        SET_LANGUAGE(state, lang) {
            state.language = lang;
        }
    },
    actions: {
        setLanguage({ commit }, lang) {
            commit('SET_LANGUAGE', lang);
        }
    },
    getters: {
        language: (state) => state.language
    }
});
